import { isEmpty } from 'lodash';

import { useAccountSelector } from './useAccountSelector';
import { useAuthenticatedUserSelector } from './useAuthenticatedUserSelector';

export const useCanSwitchAccount = (): boolean => {
  const { user } = useAuthenticatedUserSelector();
  const { account } = useAccountSelector();

  if (!user) {
    return false;
  }

  if (isEmpty(user?.accounts)) {
    return false;
  }

  if (user.accounts.length === 1 && user.accounts[0].id === account?.id && user.accountLinks.length === 0) {
    return false;
  }

  if (user.accounts.length === 1 && user.accounts[0].id !== account?.id) {
    return true;
  }

  return user.accounts.length > 1 || user.accountLinks.length > 0;
};
